import { Calendar, ExternalLink, Scale, ScrollText } from 'lucide-react';
import { usePolicySettings } from '@/backend/hooks/usePolicySettings';
import { useActiveRegulation } from '@/backend/hooks/useRegulations';

interface PolicyLinksProps {
  residenceId: string;
}

interface Row {
  key: string;
  label: string;
  url: string;
  Icon: typeof Calendar;
}

export function PolicyLinks({ residenceId }: PolicyLinksProps) {
  const { data: policies } = usePolicySettings();
  const { data: regulation } = useActiveRegulation(residenceId);

  const rows: Row[] = [];

  if (policies?.cancellationFileUrl) {
    rows.push({
      key: 'cancellation',
      label: 'Cancellation policy',
      url: policies.cancellationFileUrl,
      Icon: Calendar,
    });
  }

  if (regulation?.fileUrl) {
    rows.push({
      key: 'regulation',
      label: 'Residence regulation',
      url: regulation.fileUrl,
      Icon: ScrollText,
    });
  }

  if (policies?.landlordFileUrl) {
    rows.push({
      key: 'landlord',
      label: 'Landlord policies',
      url: policies.landlordFileUrl,
      Icon: Scale,
    });
  }

  if (rows.length === 0) return null;

  return (
    <ul className="mt-4 space-y-2 border-t border-border pt-4">
      {rows.map(({ key, label, url, Icon }) => (
        <li key={key}>
          <a
            href={url}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center justify-between gap-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            <span className="flex items-center gap-2">
              <Icon className="h-4 w-4 shrink-0" />
              {label}
            </span>
            <ExternalLink className="h-3.5 w-3.5 shrink-0" />
          </a>
        </li>
      ))}
    </ul>
  );
}
